/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategorizedLeadData
 */
export interface CategorizedLeadData {
    /**
     * 
     * @type {{ [key: string]: { [key: string]: number; }; }}
     * @memberof CategorizedLeadData
     */
    leadsByCategory?: { [key: string]: { [key: string]: number; }; };
}

/**
 * Check if a given object implements the CategorizedLeadData interface.
 */
export function instanceOfCategorizedLeadData(value: object): value is CategorizedLeadData {
    return true;
}

export function CategorizedLeadDataFromJSON(json: any): CategorizedLeadData {
    return CategorizedLeadDataFromJSONTyped(json, false);
}

export function CategorizedLeadDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategorizedLeadData {
    if (json == null) {
        return json;
    }
    return {
        
        'leadsByCategory': json['leadsByCategory'] == null ? undefined : json['leadsByCategory'],
    };
}

export function CategorizedLeadDataToJSON(json: any): CategorizedLeadData {
    return CategorizedLeadDataToJSONTyped(json, false);
}

export function CategorizedLeadDataToJSONTyped(value?: CategorizedLeadData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'leadsByCategory': value['leadsByCategory'],
    };
}

